import { ColumnMapping } from 'app/[lang]/(main)/translation/new/[[...args]]/_components/HubDbColumnMapping';

export const getTargetLanguagesHubDb = (columnMapping: ColumnMapping[]): string[] => {
  const targetLanguageCodes = columnMapping.flatMap((mapping) =>
    mapping.targetsColumn.map((target) => target.language)
  );

  return targetLanguageCodes;
};
